import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://api.civilcadpro.in/api';

function Licenses() {
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLicense, setSelectedLicense] = useState(null);

  useEffect(() => {
    fetchLicenses();
  }, []);

  const fetchLicenses = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/licenses`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLicenses(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchLicenseDetails = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/licenses/details/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSelectedLicense(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleRevoke = async (id) => {
    if (!window.confirm('Revoke this license? The plugin will be blocked on next restart.')) return;
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/licenses/revoke/${id}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchLicenses();
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  const handleReactivate = async (id) => {
    if (!window.confirm('Reactivate this license?')) return;
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/licenses/reactivate/${id}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchLicenses();
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  const handleRenew = async (id) => {
    const days = prompt('Extend by how many days?', '365');
    if (!days) return;
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/licenses/renew/${id}`, {
        expiryDays: parseInt(days)
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchLicenses();
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  if (loading) return <div className="card">Loading...</div>;

  return (
    <div>
      <h2 style={{ marginBottom: 25, color: '#1a1a2e' }}>Licenses</h2>
      
      <div className="card">
        {licenses.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#888', padding: 40 }}>No licenses found</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>License ID</th>
                <th>Customer</th>
                <th>Email</th>
                <th>Issue Date</th>
                <th>Expiry</th>
                <th>Status</th>
                <th>Details</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {licenses.map(lic => (
                <tr key={lic._id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{lic.licenseId}</td>
                  <td><strong>{lic.customerName}</strong></td>
                  <td>{lic.email}</td>
                  <td>{new Date(lic.issueDate).toLocaleDateString()}</td>
                  <td>{new Date(lic.expiryDate).toLocaleDateString()}</td>
                  <td>
                    {lic.isRevoked ? (
                      <span className="status-badge status-rejected">Revoked</span>
                    ) : new Date(lic.expiryDate) < new Date() ? (
                      <span className="status-badge status-rejected">Expired</span>
                    ) : (
                      <span className="status-badge status-approved">Active</span>
                    )}
                  </td>
                  <td>
                    <button className="btn btn-primary btn-sm" onClick={() => fetchLicenseDetails(lic._id)}>
                      View
                    </button>
                  </td>
                  <td>
                    {lic.isRevoked ? (
                      <button className="btn btn-success btn-sm" onClick={() => handleReactivate(lic._id)}>Reactivate</button>
                    ) : (
                      <>
                        <button className="btn btn-primary btn-sm" onClick={() => handleRenew(lic._id)}>Renew</button>
                        {' '}
                        <button className="btn btn-danger btn-sm" onClick={() => handleRevoke(lic._id)}>Revoke</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* License Details Modal */}
      {selectedLicense && (
        <div className="card" style={{ marginTop: 20 }}>
          <h2>License Details</h2>
          <table>
            <tbody>
              <tr><td><strong>License ID</strong></td><td>{selectedLicense.license?.licenseId}</td></tr>
              <tr><td><strong>Customer</strong></td><td>{selectedLicense.license?.customerName}</td></tr>
              <tr><td><strong>Email</strong></td><td>{selectedLicense.license?.email}</td></tr>
              <tr><td><strong>Phone</strong></td><td>{selectedLicense.license?.phone || 'N/A'}</td></tr>
              <tr>
                <td><strong>Activation Location</strong></td>
                <td>
                  {selectedLicense.activationLocation?.city || 'Unknown'}, {selectedLicense.activationLocation?.country || 'Unknown'}
                </td>
              </tr>
              <tr><td><strong>Activation IP</strong></td><td>{selectedLicense.activationIP || 'Unknown'}</td></tr>
              <tr><td><strong>Hardware ID</strong></td><td style={{ fontFamily: 'monospace', fontSize: 12 }}>{selectedLicense.license?.hardwareId}</td></tr>
              <tr><td><strong>Issue Date</strong></td><td>{new Date(selectedLicense.license?.issueDate).toLocaleString()}</td></tr>
              <tr><td><strong>Expiry Date</strong></td><td>{new Date(selectedLicense.license?.expiryDate).toLocaleString()}</td></tr>
              <tr><td><strong>Modules</strong></td><td>{selectedLicense.license?.enabledModules?.join(', ') || 'N/A'}</td></tr>
              {selectedLicense.lastCheckin && (
                <>
                  <tr><td><strong>Last Check-In</strong></td><td>{new Date(selectedLicense.lastCheckin.timestamp).toLocaleString()}</td></tr>
                  <tr><td><strong>Last Check-In IP</strong></td><td>{selectedLicense.lastCheckin.ipAddress || 'N/A'}</td></tr>
                </>
              )}
            </tbody>
          </table>
          <button className="btn btn-primary btn-sm" onClick={() => setSelectedLicense(null)} style={{ marginTop: 15 }}>Close</button>
        </div>
      )}
    </div>
  );
}

export default Licenses;